//todo test this class, changed from old syntax
export let controls = {
    //Send simple AJAX request

  /**
   *
   * @param action {string}
   * @param method {string}
   * @param success_function {function}
   * @param error_function {function}
   * @param data {string}
   */
    ajax_action(action, method, success_function, error_function, data = '') {
        if(typeof data === "object" ){
          data._token = app.csrf_token;
        }else{
          data += `&_token=${app.csrf_token}`;
        }
        if(method.toUpperCase() !== 'GET' && method.toUpperCase() !== 'POST'){
          if(typeof data === "object" ){
            data._method = method;
          }else{
            data += `&_method=${method}`;
          }
          method = 'POST';
        }

        $.ajax({
            url: action,
            method: method,
            data: data,
            success: function(data) {
                success_function(data);
            },
            error: function(data) {
                error_function(data.responseText);
            }
        })
    },
    languageSettings:{
      en:{
        error: 'Error',
        success: 'Done',
        modalConfirmTtl: 'Confirm removal',
        modalConfirmCnt: 'The object will be deleted',
        modalConfirmBtnTxt: 'Remove',
        modalConfirmBtnCancelTxt : 'Cancel'
      },

      ru:{
        error: 'Ошибка',
        success: 'Данные успешно сохранены',
        modalConfirmTtl: 'Подтвердите удаление',
        modalConfirmCnt: 'Объект будет удален',
        modalConfirmBtnTxt: 'Удалить',
        modalConfirmBtnCancelTxt : 'Отмена'
      }
    },
    getTranslate(){
      let translate = this.languageSettings[app.locale] === undefined ? this.languageSettings['en'] : this.languageSettings[app.locale]
      return translate
    }

};


// WEBPACK FOOTER //
// ./js/script/components/controls.js